/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Card, CircularProgress, Divider, IconButton, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { _Tokens } from '../../types';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { userSelector } from '../user/userSlice';
import ApiSingWallet from "libs/apiSingWallet";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import { iconTokens } from "libs/constans";
import { changePopupAction, changePopupStep, changePopupTokenSelected, popupSelector, setNftDetails, setNftMetadata, setNftTab, setNftToken } from './popupSlice';
import SelectToken from "./SelectToken";
import { tokenActionTypeEnum, walletStepEnum } from '../../libs/constans';
import TransactionToken from "./TransactionToken";
import ReceiveToken from "./ReceiveToken";
import { TokenDetails } from "./TokenDetails";
import queryString from 'query-string';
import NftList from "components/Nft";
import NftDetails from "components/NftDetails";

export default function WalletDetails() {

    const { walletId } = useParams<any>();
    const qs = queryString.parse(window.location.search);
    const walletName = qs.walletName as string;
    const dispatch = useAppDispatch();

    const [tokens, setTokens] = useState<_Tokens[]>([]);
    const [pending, setPending] = useState(false);
    const api = new ApiSingWallet();

    const { user, tokenBearer } = useAppSelector(userSelector);
    const { step, isUpdated, nftDetails } = useAppSelector(popupSelector)

    const getTokenList = async (walletId) => {
        setPending(true);
        try {
            await api.getListToken(walletId, tokenBearer).then(
                (result) => {
                    setTokens(result.result)
                },
                (error) => {
                    console.log(error!.message)
                }
            )
        } catch (e) {
            console.log(e);
        } finally {
            setPending(false);
        }
    }

    useEffect(() => {
        if (!pending) {
            getTokenList(walletId)
        }
        dispatch(setNftTab(false));
        dispatch(setNftDetails(false));
    }, [walletId, user, isUpdated])

    return (
        <Fragment>
            <Box id="wallet-listing"
                sx={{
                    paddingTop: 1.2,
                }}
            >
                {step === walletStepEnum.WALLET_DETAILS &&
                    <>
                        <WalletNav title={nftDetails ? "NFT Details" : "Wallet Details"} />
                        <Box
                            sx={{
                                display: !nftDetails ? 'block' : 'none',
                            }}
                        >
                            <TokenList tokens={tokens} walletName={walletName} />
                        </Box>
                        <Box
                            sx={{
                                display: nftDetails ? 'block' : 'none',
                            }}
                        >
                            <NftDetails />
                        </Box>
                        {pending &&
                            <Box sx={{ textAlign: 'center' }}>
                                <CircularProgress />
                            </Box>
                        }
                    </>
                }
                {step === walletStepEnum.SELECT_TOKEN &&
                    <SelectToken tokens={tokens} />
                }
                {(step > walletStepEnum.SELECT_TOKEN && step < walletStepEnum.RECEIVE_TOKEN) &&
                    <TransactionToken />
                }
                {step === walletStepEnum.RECEIVE_TOKEN &&
                    <ReceiveToken />
                }
                {step === walletStepEnum.TOKEN_DETAILS &&
                    <TokenDetails />
                }

            </Box>
        </Fragment>
    )
}


const styles = {
    background: `linear-gradient(90deg, #BF26E6 -5.41%, #3C14DA 100%)`,
    borderRadius: '20px',
    textAlign: 'center'
} as const;

const styles_0 = {
    backgroundColor: '313544',
    borderRadius: '20px',
    textAlign: 'center'
} as const;

export function TokenList({ tokens, walletName }: { tokens: _Tokens[], walletName: string }) {

    const dispatch = useAppDispatch();
    const { defaultWalletSymbol, ratio, nftTab } = useAppSelector(popupSelector)
    const [visible, setVisible] = useState(true);

    const handleSendToken = () => {
        dispatch(changePopupStep(walletStepEnum.SELECT_TOKEN))
        dispatch(changePopupAction(tokenActionTypeEnum.SEND))
    }

    const handleReceiveToken = () => {
        dispatch(changePopupStep(walletStepEnum.SELECT_TOKEN))
        dispatch(changePopupAction(tokenActionTypeEnum.RECEIVE))
    }
    if (!tokens || tokens.length === 0) {
        return <></>
    }

    const handleVisible = () => {
        setVisible(!visible);
    }

    const defaultWallet = tokens.filter(v => v.symbol === defaultWalletSymbol)[0];
    if(!defaultWallet){
        return <>
            <Typography textAlign="center">
                No token available!
            </Typography>
        </>
    }
    const amountUSDTString = defaultWallet ? (parseFloat(defaultWallet.balance) * ratio[defaultWallet.symbol]).toFixed(2) : "???";

    return (
        <Fragment>
            <Card sx={styles_0}>
                <Card sx={styles}>
                    <Box p={1}>
                        <Typography>{walletName}</Typography>
                        <Box
                            onClick={handleVisible}
                        >
                            {visible ?
                                <VisibilityOffIcon />
                                :
                                <VisibilityIcon />
                            }
                        </Box>

                    </Box>
                    <Box>
                        <Typography
                            sx={{
                                fontSize: '42px',
                                fontWeight: 500,
                            }}
                        >
                            {visible ? `$${amountUSDTString}` : `******`}
                        </Typography>
                    </Box>
                    <Box sx={{ mb: 2 }}>
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{defaultWallet.balance}&nbsp;{defaultWallet.symbol}</Typography>
                    </Box>
                </Card>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mx: 5, p: 2 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            opacity: 0.6,
                            cursor: 'pointer',
                        }}
                        onClick={handleSendToken}
                    >
                        <UploadIcon />
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Send</Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            opacity: 0.6,
                            cursor: 'pointer',
                        }}
                        onClick={handleReceiveToken}
                    >
                        <DownloadIcon />
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Receive</Typography>
                    </Box>
                </Box>

            </Card>
            <Box
                sx={{
                    display: nftTab ? 'block' : 'none',
                }}
            >
                <NftList />
            </Box>

            <Box mt={2}
                sx={{
                    display: !nftTab ? 'block' : 'none',
                }}
            >
                {tokens && tokens.map((item, index) => (

                    <TokenItem key={index} item={item} />

                ))
                }
                {tokens && tokens.length > 0 &&
                    <Divider />
                }

            </Box>
        </Fragment>
    )
}

export function TokenItem({ item }: { item: _Tokens }) {

    const dispatch = useAppDispatch();
    const { ratio } = useAppSelector(popupSelector)

    const handleClick = () => {
        dispatch(changePopupTokenSelected(item))
        dispatch(changePopupStep(walletStepEnum.TOKEN_DETAILS))
    }

    const amountUSDTString = ratio[item.symbol] ? (parseFloat(item.balance) * ratio[item.symbol]).toFixed(2) : "";
    return (
        <Fragment>
            <Divider />
            <Box p={2}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                }}
                onClick={handleClick}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ mr: 1.5 }}>
                        <object data={iconTokens[item.symbol]} width={42} height={42}> </object>
                    </Box>
                    <Box>
                        <Typography>{item.symbol}</Typography>
                    </Box>
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                    <Typography sx={{ fontSize: '14px' }}>{item.balance}&nbsp;{item.symbol}</Typography>
                    <Typography sx={{ fontSize: '14px', color: '#D68DDE' }}>{amountUSDTString ? `$` : ''}{amountUSDTString}</Typography>
                </Box>

            </Box>
        </Fragment>
    )
}

export function WalletNav({ title }: { title: string }) {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const { nftTab, nftDetails } = useAppSelector(popupSelector);
    const handleBack = () => {
        if (nftDetails) {
            dispatch(setNftDetails(false));
            dispatch(setNftToken(null));
            dispatch(setNftMetadata(null));

        } else {
            history.goBack();
        }
    }
    const handleSelectTab = (value) => {
        dispatch(setNftTab(value));
    }

    return (
        <Fragment>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1
                }}
            >
                <IconButton onClick={handleBack}>
                    <KeyboardBackspaceIcon />
                </IconButton>
                <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{title}</Typography>

                <IconButton >

                </IconButton>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    height: 36,
                    background: '#353B4F',
                    borderRadius: '50px',
                    mb: 3,
                    display: nftDetails ? 'none' : 'flex',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        width: '50%',
                        height: '100%',
                        borderRadius: '50px',
                        background: nftTab ? '#353B4F' : '#5F667E',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                    }}
                    onClick={() => handleSelectTab(false)}
                >
                    <Typography
                        sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: nftTab ? '#BBCEFF' : '#ffffff',
                        }}
                    >
                        Token
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: '50%',
                        height: '100%',
                        borderRadius: '50px',
                        background: !nftTab ? '#353B4F' : '#5F667E',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                    }}
                    onClick={() => handleSelectTab(true)}
                >
                    <Typography
                        sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: !nftTab ? '#BBCEFF' : '#ffffff',
                        }}
                    >
                        NFT
                    </Typography>
                </Box>
            </Box>
        </Fragment>
    );
}